/*
 * Pictogramele din navigatie si din ecrane, desenate inline.
 *
 * Inline si nu emoji: emoji-urile se deseneaza cu fontul de emoji al statiei,
 * arata altfel pe Windows fata de macOS, si intr-o aplicatie de banca citesc a
 * jucarie. Inline si nu o fonteca de iconite: ar fi un fisier descarcat in plus
 * pentru cinci forme, iar reteaua e inchisa.
 *
 * Toate sunt `aria-hidden`: fiecare sta langa eticheta ei scrisa, deci pentru un
 * cititor de ecran n-ar adauga decat un al doilea nume pentru acelasi link.
 */

export type IconName =
  | 'catalog' | 'cart' | 'requests' | 'menu' | 'close' | 'ticket' | 'help'
  | 'chevron' | 'bell' | 'clip' | 'image';

const PATHS: Record<IconName, string> = {
  catalog: 'M3.5 3.5h6v6h-6zM12.5 3.5h6v6h-6zM3.5 12.5h6v6h-6zM12.5 12.5h6v6h-6z',
  cart: 'M2.5 3.5h2.2l2.1 9.6h9.3l2.1-7.1H6.2M8.5 18a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8zM16 18a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8z',
  requests: 'M4.5 3.5h9l4 4v13h-13zM13.5 3.5v4h4M7.5 12h7M7.5 15.5h7',
  menu: 'M3.5 6h17M3.5 12h17M3.5 18h17',
  close: 'M5.5 5.5l13 13M18.5 5.5l-13 13',
  /* Documentul din `requests`, cu plus in loc de randuri: acelasi obiect,
     dar unul care abia se naste. Plusul singur ar fi citit "adauga in cos". */
  ticket: 'M4.5 3.5h9l4 4v13h-13zM13.5 3.5v4h4M12 10.5v5M9.5 13h5',
  /* Carte deschisa, nu un semn de intrebare: articolele nu raspund la
     intrebari puse cuiva, sunt un lucru de citit. Semnul de intrebare e si
     eticheta obisnuita a ajutorului DESPRE aplicatie, care nu e asta. */
  help: 'M12 6.5C10 5 7.5 4.7 4.5 5.2v12c3-.5 5.5-.2 7.5 1.3 2-1.5 4.5-1.8 7.5-1.3v-12c-3-.5-5.5-.2-7.5 1.3zM12 6.5v12',
  /* Semnul ca randul duce undeva. O sageata intreaga ar fi cerut sa fie apasata
     chiar ea; varful singur spune doar „mai e ceva dincolo". */
  chevron: 'M9.5 5.5l6.5 6.5-6.5 6.5',
  /* Clopotel: ti-a scris cineva. Nu un plic - plicul ar fi spus „ai un mesaj de
     citit undeva", cand aici lucrul e chiar tichetul de sub el. */
  bell: 'M12 3.5a5 5 0 0 0-5 5v3.2l-1.5 3.3h13L17 11.7V8.5a5 5 0 0 0-5-5zM10 18a2 2 0 0 0 4 0',
  /* Agrafa: "ataseaza". E semnul pe care il stie toata lumea din email. */
  clip: 'M18 8.5l-7.2 7.2a2.5 2.5 0 0 1-3.5-3.5l7.6-7.6a4 4 0 0 1 5.7 5.7l-7.7 7.7a5.5 5.5 0 0 1-7.8-7.8L12 3.2',
  /* Poza: dreptunghi cu un deal si un soare - se deosebeste de agrafa dintr-o
     privire, ceea ce e tot rostul ei intr-o lista de fisiere. */
  image: 'M4 5.5h16v13H4zM4 15l4.5-4.5 3.5 3.5 3-3 5 5M15.5 9.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z',
};

export function Icon({ name }: { name: IconName }) {
  return (
    <svg
      className="icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
